<header class="header user-head">
  <nav class="navbar navbar-expand-md">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>


      <div class="collapse navbar-collapse" id="navbarsExample04">
        <div class="algn-head-rt ml-auto">
          <div class="navwrap">
            <ul class="navbar-nav mr-auto">
              <!--<li>
                <i [routerLink]="[ '/store/viewemdproduct' ]" class="fa fa-eye" aria-hidden="true"></i>
              </li>-->
              <li *ngIf="CartItemCount > 0" class="level-1">
                <a [routerLink]="[ '/store/cart' ]">
                  <app-cart [color]="cartColor"></app-cart>
                  <span class="badge badge-cart">{{CartItemCount}}</span>
                </a>

              </li>
              <li class="level-1">
                <div class="dash-avt-wrp dropdown">
                  <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">
                    <div class="dash-avt">
                      <img id="file-image" [src]="ProfileimageSrc || 'assets/img/default_user_img.png'" alt="dashboard">
                      <!-- <img src="assets/img/default_user_img.png" alt="dashboard"> -->
                    </div>
                    <div class="dash-content">
                      <h4>{{FullName}}</h4>
                    </div>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="fn_ShowReleaseLog()">
                        <i class="fa fa-flag-o" aria-hidden="true"></i> What's New?
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" [routerLink]="[ '/store/adminaccount' ]" [routerLinkActive]="['active-link']">
                        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                        Account
                      </a>
                    </li>
                    <li style="cursor: pointer;">
                      <a class="dropdown-item" (click)="logout()">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

            </ul>
          </div>
        </div>

      </div>
    </div>
  </nav>

  <div id="google_code">
  </div>
  <div id="facebook_pixel">
  </div>
</header>
